import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CreditCard } from "@phosphor-icons/react";

const STATUS_COLOR = { paid: "#00E5FF", pending: "#8A8A93", expired: "#EF4444", failed: "#EF4444", initiated: "#8A8A93" };
const PLAN_LABEL = { standard: "Offre unique", monthly: "Mensuel", annual: "Annuel", lifetime: "À vie" };

export default function AdminPayments() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/payments").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-payments">
      <div className="overline mb-2">Suivi</div>
      <h1 className="font-display text-3xl font-bold mb-8">Paiements & abonnements <span className="text-muted text-lg font-mono">({items.length})</span></h1>

      {loading ? (
        <div className="text-muted font-mono text-sm animate-pulse">Chargement…</div>
      ) : items.length === 0 ? (
        <div className="surface rounded-lg p-10 text-center" data-testid="payments-empty">
          <CreditCard size={40} className="text-muted mx-auto mb-3" />
          <p className="text-muted">Aucune transaction pour l'instant.</p>
        </div>
      ) : (
        <div className="surface rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left border-b border-border text-muted">
                  <th className="px-4 py-3 overline font-medium">Client</th>
                  <th className="px-4 py-3 overline font-medium">Plan</th>
                  <th className="px-4 py-3 overline font-medium">Montant</th>
                  <th className="px-4 py-3 overline font-medium">Statut</th>
                  <th className="px-4 py-3 overline font-medium">Session</th>
                </tr>
              </thead>
              <tbody>
                {items.map((p) => (
                  <tr key={p.id} className="border-b border-border/60 hover:bg-surface-2/40" data-testid={`payment-row-${p.id}`}>
                    <td className="px-4 py-3 text-fg font-mono text-xs">{p.user_email}</td>
                    <td className="px-4 py-3 text-fg">{PLAN_LABEL[p.plan] || p.plan || "—"}</td>
                    <td className="px-4 py-3 font-mono text-fg">{p.amount_eur} €</td>
                    <td className="px-4 py-3">
                      <span className="text-xs font-mono px-2 py-0.5 rounded border" style={{ color: STATUS_COLOR[p.payment_status] || "#8A8A93", borderColor: (STATUS_COLOR[p.payment_status] || "#8A8A93") + "55" }}>
                        {p.payment_status}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-muted font-mono text-xs truncate max-w-[180px]">{p.session_id}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
